import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditSuppressionList = lazy(() =>
  import("@scenes/SuppressionLists/components/EditSuppressionList").then((module) => ({
    default: module.EditSuppressionList,
  }))
);

export const suppressionListsDetailsNRO: NavigationRoutingObject = {
  Component: EditSuppressionList,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("suppression-lists-nro-heading", "Suppression Lists"),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/suppression_lists/:appGroupId",
};
